// eslint-disable-next-line lodash/import-scope
import get from "lodash.get";
import styled, { css } from "../styled";
import { Stack as BaseStack } from "./stack";
const baseSpaceValues = ["inherit", "initial", "unset", "0"];
const resolveValue = (allowedValues) => (value, space) => {
    if (allowedValues.includes(value)) {
        return value;
    }
    return get(space, value, value);
};
const resolvePadding = resolveValue(baseSpaceValues);
const resolveMargin = resolveValue([...baseSpaceValues, "auto"]);
const dimensionsSelector = ({ height, minHeight, maxHeight, width, minWidth, maxWidth, }) => {
    return css `
    ${height && `height: ${height};`}
    ${minHeight && `min-height: ${minHeight};`}
    ${maxHeight && `max-height: ${maxHeight};`}
    ${width && `width: ${width};`}
    ${minWidth && `min-width: ${minWidth};`}
    ${maxWidth && `max-width: ${maxWidth};`}
  `;
};
const paddingSelector = ({ paddingInlineStart, paddingInlineEnd, paddingInline, padding, paddingTop, paddingRight, paddingBottom, paddingLeft, paddingX, paddingY, theme, }) => {
    const { space } = theme._ui;
    return css `
    ${paddingInlineStart &&
        `padding-inline-start: ${resolvePadding(paddingInlineStart, space)};`}
    ${paddingInlineEnd &&
        `padding-inline-end: ${resolvePadding(paddingInlineEnd, space)};`}
    ${paddingInline &&
        `padding-inline: ${resolvePadding(paddingInline, space)};`}
    ${paddingTop && `padding-top: ${resolvePadding(paddingTop, space)};`}
    ${paddingRight && `padding-right: ${resolvePadding(paddingRight, space)};`}
    ${paddingBottom &&
        `padding-bottom: ${resolvePadding(paddingBottom, space)};`}
    ${paddingLeft && `padding-left: ${resolvePadding(paddingLeft, space)};`}
    ${paddingX &&
        `padding-left: ${resolvePadding(paddingX, space)}; padding-right: ${resolvePadding(paddingX, space)};`}
    ${paddingY &&
        `padding-top: ${resolvePadding(paddingY, space)}; padding-bottom: ${resolvePadding(paddingY, space)};`}
    ${padding && `padding: ${resolvePadding(padding, space)};`}
  `;
};
const marginSelector = ({ marginInlineStart, marginInlineEnd, marginInline, margin, marginTop, marginRight, marginBottom, marginLeft, marginX, marginY, theme, }) => {
    const { space } = theme._ui;
    return css `
    ${marginInlineStart &&
        `margin-inline-start: ${resolveMargin(marginInlineStart, space)};`}
    ${marginInlineEnd &&
        `margin-inline-end: ${resolveMargin(marginInlineEnd, space)};`}
    ${marginInline && `margin-inline: ${resolveMargin(marginInline, space)};`}
    ${marginTop && `margin-top: ${resolveMargin(marginTop, space)};`}
    ${marginRight && `margin-right: ${resolveMargin(marginRight, space)};`}
    ${marginBottom && `margin-bottom: ${resolveMargin(marginBottom, space)};`}
    ${marginLeft && `margin-left: ${resolveMargin(marginLeft, space)};`}
    ${marginX &&
        `margin-left: ${resolveMargin(marginX, space)}; margin-right: ${resolveMargin(marginX, space)};`}
    ${marginY &&
        `margin-top: ${resolveMargin(marginY, space)}; margin-bottom: ${resolveMargin(marginY, space)};`}
    ${margin && `margin: ${resolveMargin(margin, space)};`}
  `;
};
const backgroundColorSelector = ({ backgroundColor, theme, }) => {
    if (!backgroundColor) {
        return "";
    }
    let selectedColor;
    if (backgroundColor === "inherit" || backgroundColor === "transparent") {
        selectedColor = backgroundColor;
    }
    else {
        selectedColor = get(theme._ui.colors, backgroundColor);
    }
    return css `
    background-color: ${selectedColor};
  `;
};
const spaceSelector = ({ spacing, theme }) => {
    if (!spacing) {
        return "";
    }
    const { space } = theme._ui;
    const selectedSpace = get(space, spacing);
    return css `
    gap: ${selectedSpace};
  `;
};
export const Stack = styled(BaseStack).withConfig({
    shouldForwardProp: (prop, defaultValidator) => {
        if ([
            "spacing",
            "direction",
            "margin",
            "marginTop",
            "marginRight",
            "marginBottom",
            "marginLeft",
            "marginX",
            "marginY",
            "marginInlineStart",
            "marginInlineEnd",
            "marginInline",
            "padding",
            "paddingTop",
            "paddingRight",
            "paddingBottom",
            "paddingLeft",
            "paddingX",
            "paddingY",
            "paddingInlineStart",
            "paddingInlineEnd",
            "paddingInline",
            "height",
            "minHeight",
            "maxHeight",
            "width",
            "minWidth",
            "maxWidth",
        ].includes(prop)) {
            return false;
        }
        if (["component"].includes(prop)) {
            return true;
        }
        return defaultValidator(prop);
    },
}) `
  width: 100%;
  display: flex;
  flex-direction: ${(p) => p.direction};
  flex-wrap: ${(p) => p.wrap};
  flex-basis: ${(p) => p.basis};
  align-items: ${(p) => p.align};
  justify-content: ${(p) => p.justify};
  ${spaceSelector}
  ${dimensionsSelector}
  ${marginSelector}
  ${paddingSelector}
  ${backgroundColorSelector}
`;
// Required for StoryBook documentation, do not import
export const _ = Stack;
export const HStack = styled(Stack) `
  flex-direction: row;
`;
export const VStack = styled(Stack) `
  flex-direction: column;
`;
